







import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'

@Component
export default class TitleBack extends ViewBase {
  @Prop({ type: String, default: '' }) title!: string
  @Prop({ type: String, default: '' }) routerLink!: string

  lang = {}
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  backClick() {
    this.$router.push({ name: this.routerLink })
  }

  created() {
    this.lang = this.i18n.vBinding
  }
}
